import React, { useState } from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap'

// Import Libraries
import { Link } from 'react-router-dom'
import { FaArrowLeft } from 'react-icons/fa'

// Import Components
import AnswerOptionCard from '../../../components/accounts/AnswerOptionCard'

// Demo Data
const answers = [
  {
    id: 1,
    answer: 'Web Developer',
  },
  {
    id: 2,
    answer: 'Software Engineer',
  },
  {
    id: 3,
    answer: 'Project Manager',
  },
  {
    id: 4,
    answer: 'Data Analyst',
  },
]

const AssessmentTest = () => {
  const [selected, setSelected] = useState(false)

  return (
    <Container fluid className='assessment-test-page'>
      <Row>
        <Col md={6}>
          <div className='mb-5'>
            <Link
              to='/dashboard'
              style={{ color: 'black', textDecoration: 'none' }}
            >
              <FaArrowLeft style={{ fontSize: '12px', marginRight: '6px' }} />{' '}
              Go to Dashboard
            </Link>
          </div>
          <h4>Assessment Test</h4>
          <p>Question 1/10</p>

          <div className='mt-5 question'>
            <h4>What is your responsibility in the team?</h4>
          </div>
        </Col>
        <Col md={6}>
          <Row>
            <Col md={4}>Select one answer</Col>
            <Col md={4} className='text-center'>
              00:00:00
            </Col>
            <Col md={4} style={{ textAlign: 'end' }}>
              <Button variant='primary'>Next Question</Button>
            </Col>
          </Row>
          <div className='answers mt-5'>
            <div className='radio-toolbar'>
              {answers &&
                answers.map((answer, idx) => (
                  <AnswerOptionCard
                    key={idx}
                    id={answer.id}
                    answer={answer.answer}
                  />
                ))}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default AssessmentTest
